export enum WidgetKeys {
  CASHFLOW_THROUGH_TIME = 'cashflowThroughTime',
  DEBT_HEDGE_SCHEDULE = 'debtHedgeSchedule',
  PRICING_SUMMARY = 'pricingSummary',
  IR_MARKET_ENVIRONMENT = 'irMarketEnvironment',
}
